// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useEffect } from 'react'
import { useAdjustPageHeadEntities } from 'ui_kit_qmd'
import { QUICK_MD_TITLE_TEXT } from '../../utils/constants'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
const CustomTabTitle = ({ pageTitle, children }) => {
  const pageHeader = useAdjustPageHeadEntities({
    title: pageTitle,
  })
  useEffect(
    () => () => {
      document.title = QUICK_MD_TITLE_TEXT
    },
    [],
  )
  return (
    <>
      {pageHeader}
      {children}
    </>
  )
}

export default CustomTabTitle
